import React, { useState, useEffect, useContext } from 'react';
import { Container, Spinner, Row } from 'reactstrap';
import { GlobalContext } from '../../context/GlobalContext';
import { CardMateria } from '../cards/CardMateria';
import { SinMaterias } from '../Errors/SinMaterias';
import {Header} from "../header/Header";
import $ from 'jquery'

export const Home = () => {

    //GET GLOBAL CONTEXT
    const context = useContext(GlobalContext);
    const { Calificaciones, darkTheme, isMobile, setIsMobile } = context;

    //State declarations
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        if (Calificaciones) {
            setData(Calificaciones.data);
            setIsMobile(Calificaciones.isMobile);
            setIsLoading(false);
            console.log(Calificaciones);
        }
    }, [Calificaciones]);

///////////////////////// ocultar Header Calificaciones  ///////
var searchIndex = window.location.href.search("materias");

if (searchIndex > -1) {  
     


 //$('header').css('visibility', 'hidden');
  //document.getElementsByClassName("header")[0].style.display="none";  
 //document.querySelector(".item1").style.display="none"
 //document.getElementById("item1").style.visibility="hidden";
//    }else
//{

  //  alert("No sE quito el Header");
}


//////////////////////////////////////////////////////////////////

    return (

        

        <>



      {searchIndex > -1 ? (
   <Header  title={'Mis Calificaciones'} />
      ) : (
        <p></p>
      )}



     
    
            {
                (isLoading) ?
                    <Container className="spinner-container">
                        <Spinner style={{ width: '3rem', height: '3rem' }} color="primary" />
                    </Container>
                    :
                    <Container className={(darkTheme) ? "home__bg-white bg-dark-primary" : "home__bg-white"}>
                        {
                            (data.length > 0) ?
                                <Row>
                                    {
                                        data.map((item, index) => (
                                            <CardMateria key={item.relationships.materiaRelacionada.data.id} data={item} darkTheme={darkTheme} />
                                        ))
                                    }
                                </Row>
                                :
                                <SinMaterias />
                        }
                    </Container>
            }
        </>
    );
}
